<template>
  <div id="app">
    <site-header :language="language" @change-language="setLanguage" />
    <main class="page-shell">
      <router-view :language="language" />
    </main>
    <site-footer v-if="$route.path !== '/'" :language="language" />
    <back-to-top />
  </div>
</template>

<script>
import SiteHeader from './components/SiteHeader.vue';
import SiteFooter from './components/SiteFooter.vue';
import BackToTop from './components/BackToTop.vue';

export default {
  name: 'App',
  components: {
    SiteHeader,
    SiteFooter,
    BackToTop
  },
  data: function () {
    return {
      language: 'en'
    };
  },
  methods: {
    setLanguage: function (language) {
      this.language = language;
    }
  }
};
</script>
